import { CheckCircleFilled } from '@ant-design/icons';
import * as React from 'react';
import { cn } from '../../../utils/ClassNamesUtils';
import { useOscarTheme } from '../../context/OscarRoleContext';

interface OscarTeamRequestSentCardProps {
	/** What was sent, in Oscar's words — the same text the customer approved. */
	request: string;
	className?: string;
}

/**
 * Confirmation that a request reached the OpenWrench team. Driven by the
 * harness's `team_request` event, which it sends only once the post landed —
 * the approval card alone cannot say this, because approving is not the same
 * as the request getting through.
 *
 * It promises a follow-up, never the work: the team decides what happens next.
 */
export const OscarTeamRequestSentCard = ({ request, className }: OscarTeamRequestSentCardProps) => {
	const theme = useOscarTheme();
	return (
		<div
			className={cn(
				'flex w-full min-w-0 items-start gap-s rounded border border-solid border-grey-4 bg-grey-2 p-xs',
				className
			)}
		>
			<span aria-hidden="true" className={cn('shrink-0 text-[18px]', theme.accentText)}>
				<CheckCircleFilled />
			</span>
			<span className="flex min-w-0 flex-1 flex-col gap-2xs">
				<span className="bodymedium text-character-primary">Sent to the OpenWrench team</span>
				<span className="bodyregular whitespace-pre-wrap break-words text-grey-9">{request}</span>
				<span className="footnoteregular text-character-secondary">
					Someone from the team will follow up by email.
				</span>
			</span>
		</div>
	);
};

export default OscarTeamRequestSentCard;
